import AppRoutes from '../config/appRoutes';
var AuthSerivce = /** @class */ (function () {
    function AuthSerivce() {
    }
    AuthSerivce.getToken = function () {
        return localStorage.getItem(this.authTokenKey);
    };
    AuthSerivce.breakSession = function (history) {
        localStorage.removeItem(this.authTokenKey);
        history.push(AppRoutes.login.path);
    };
    AuthSerivce.userLogin = function (history, resp) {
        localStorage.setItem(this.authTokenKey, resp.authentication_token);
        history.push(AppRoutes.base.path);
    };
    AuthSerivce.userLogout = function (history) {
        if (localStorage.getItem(this.authTokenKey)) {
            localStorage.removeItem(this.authTokenKey);
        }
        history.push(AppRoutes.login.path);
    };
    AuthSerivce.authTokenKey = 'authToken';
    return AuthSerivce;
}());
export default AuthSerivce;



//////////////////
// WEBPACK FOOTER
// ./src/classes/auth.service.ts
// module id = 41
// module chunks = 0